// extracted by mini-css-extract-plugin
export default {"testSearch":"_XU0ShmW_mbnWZCi6cZJ3","text-map":"_1ueYeMKDlmXHF1xPVD6xyJ","col-lg-8":"STVJ951L4W8I2Fh5BslyQ","col-lg-4":"_21MiZBShM82__fXi2Z13yK","loading":"_2zxh3IbvW7KLw_3OL5mFOL"};